import { render, staticRenderFns } from "./gongjiangschool.vue?vue&type=template&id=a700b3fe&"
import script from "./gongjiangschool.vue?vue&type=script&lang=js&"
export * from "./gongjiangschool.vue?vue&type=script&lang=js&"
import style0 from "./gongjiangschool.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports